import React from "react";

const AzadKashmir = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default AzadKashmir;
